<template>
  <div :class="classes">
    <div v-if="title" class="flex items-center justify-between gap-8 pb-6 text-slate-900">
      <h4 class="text-sm font-bold">
        {{ title }}
      </h4>
      <button v-if="showClose" class="text-slate-500 hover:text-slate-700" @click="close">
        <XMarkIcon class="h-5 w-5"/>
      </button>
    </div>
    <slot/>
  </div>
</template>

<script setup>
import {XMarkIcon} from "@heroicons/vue/24/solid";
import {computed} from "vue";
import {twMerge} from "tailwind-merge";

const emits = defineEmits(["close"]);
const props = defineProps({
  title: String,
  noPadding: Boolean,
  minPaddingSmall: Boolean,
  showClose: Boolean,
  class: String,
});

const classes = computed(() => twMerge(
  "rounded-lg bg-white shadow ring ring-slate-500 ring-opacity-5",
  !props.noPadding && "p-4 sm:px-6",
  props.minPaddingSmall && "px-2 py-2 sm:px-4 sm:py-2",
  props.class,
));

const close = () => emits("close");
</script>
